import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity, Linking} from 'react-native';

const COLUMNS = [
  {
    title: "L'OFFRE WIZZEE",
    links: [
      {label: 'eSIM Wizzee', url: 'https://www.wizzee.fr/esim-wizzee/'},
      {label: 'Nos forfaits', url: 'https://www.wizzee.fr/forfait/'},
      {label: 'Souscrire', url: 'https://www.wizzee.fr/je-souscris/'},
    ],
  },
  {
    title: 'INFORMATIONS UTILES',
    links: [
      {label: 'Réseau', url: 'https://www.wizzee.fr/reseau/'},
      {label: 'CGV', url: 'https://www.wizzee.fr/conditions-generales-de-vente/'},
      {label: 'Mentions légales', url: 'https://www.wizzee.fr/mentions-legales/'},
      {label: 'Confidentialité', url: 'https://www.wizzee.fr/politique-de-confidentialite/'},
    ],
  },
  {
    title: 'ASSISTANCE',
    links: [
      {label: 'Activer ma SIM', url: 'https://www.wizzee.fr/assistance/'},
      {label: 'Suivi commande', url: 'https://www.wizzee.fr/assistance/'},
      {label: 'Contact', url: 'https://www.wizzee.fr/assistance/'},
    ],
  },
  {
    title: 'SUIVEZ-NOUS',
    links: [
      {label: 'Facebook', url: 'https://facebook.com/wizzee.fwi'},
      {label: 'Instagram', url: 'https://instagram.com/wizzee.fwi'},
      {label: 'Twitter / X', url: 'https://twitter.com/wizzee_fwi'},
    ],
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <View style={styles.footerContainer}>
      <View style={styles.columnsWrapper}>
        {COLUMNS.map((column) => (
          <View key={column.title} style={styles.column}>
            <Text style={styles.columnTitle}>{column.title}</Text>
            {column.links.map((link) => (
              <TouchableOpacity
                key={link.label}
                onPress={() => Linking.openURL(link.url)}>
                <Text style={styles.linkText}>{link.label}</Text>
              </TouchableOpacity>
            ))}
          </View>
        ))}
      </View>

      <View style={styles.divider} />

      <Text style={styles.copyright}>
        © {currentYear} Wizzee tous droits réservés. Wizzee est une marque
        Digicel.
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    width: '100%',
    backgroundColor: '#FF0000',
    paddingVertical: 40,
    paddingHorizontal: 20,
    alignItems: 'center',
    marginTop: 'auto',
  },
  columnsWrapper: {
    width: '100%',
    maxWidth: 1200,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  column: {
    minWidth: 180,
    marginBottom: 24,
    paddingHorizontal: 10,
  },
  columnTitle: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '700',
    fontFamily: 'Gotham',
    marginBottom: 12,
    letterSpacing: 0.5,
  },
  linkText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontFamily: 'Gotham',
    fontWeight: '400',
    paddingVertical: 4,
  },
  divider: {
    width: '100%',
    maxWidth: 1200,
    height: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    marginTop: 6,
    marginBottom: 20,
  },
  copyright: {
    color: '#FFFFFF',
    fontSize: 12,
    fontFamily: 'Gotham',
    textAlign: 'center',
  },
});

export default Footer;
